export default __webpack_public_path__ + "static/media/construction.8a709d4d.png";